'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ref = {};

exports.__exports = ref;
